import { z } from "zod";

import { PRACTICE_RUBRIC_DIMENSIONS, type PracticeAnswerFeedback } from "./feedback";

/** The retry drill: one question, answered again out loud, capped at this many seconds. */
export const PRACTICE_DRILL_SECONDS = 60;

/** A pattern across the candidate's recent sessions, computed from their rubric levels. */
export const practicePatternSchema = z.object({
  kind: z.enum(["weakest", "slipping", "improving", "strength"]),
  dimension: z.enum(PRACTICE_RUBRIC_DIMENSIONS),
  title: z.string(),
  body: z.string(),
});
export type PracticePattern = z.infer<typeof practicePatternSchema>;

/** The answer most worth redoing from the latest session. */
export type PracticeDrillSuggestion = {
  sessionId: string;
  questionIndex: number;
  question: string;
  change: string;
  score: number;
};

export type PracticeDrillResult = {
  before: PracticeAnswerFeedback;
  after: PracticeAnswerFeedback;
  /** Whether the redo acted on the advice it was given (Jev); null without Jev. */
  appliedAdvice?: { advice: string; applied: boolean; p: number } | null;
};

/** What an adaptive next round focuses on, kept with the new session's prep. */
export type PracticeRoundFocus = {
  fromSessionId: string;
  /** The rubric part that was weakest across the last session's answers. */
  dimension: string | null;
  /** Job requirements the last session's answers never showed. */
  requirements: string[];
  /** The weakest answer's question, asked again first. */
  repeatQuestion: string | null;
};
